import React, { PureComponent } from 'react';
import { animateScroll as scroll } from 'react-scroll';

import L2CategoryNavItem from '../../../Components/L2CategoriesList/L2CategoriesNavItem';

import './AllCategoriesNav.scss';
import type { AllCategoriesNav$Props } from '../AllCategories.helpers';

class AllCategoriesNav extends PureComponent<AllCategoriesNav$Props> {
  /* @ts-expect-error type mismatch */
  scrollTo = (e: SyntheticMouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey) {
      // If link clicked with Cmd/Ctrl key -> allow open l2 category page in new tab
      return;
    }

    e.preventDefault();

    const { sectionId } = e.currentTarget.dataset;
    const categoryEl = document.getElementById(sectionId);
    const categoryTop = categoryEl ? categoryEl.offsetTop : 0;

    scroll.scrollTo(categoryTop - 60, { duration: 300 });
  };

  render() {
    const { topCategories } = this.props;

    return (
      <nav className="allCategoriesNav">
        <ul className="allCategoriesNav__list">
          {topCategories.map((category) => (
            <li className="allCategoriesNav__item" key={category.slug}>
              <L2CategoryNavItem category={category} data-section-id={category.slug} onClick={this.scrollTo} />
            </li>
          ))}
        </ul>
      </nav>
    );
  }
}

export default AllCategoriesNav;
